//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

/**
 * Identifier for a social media post (the network's bare post id, e.g. the
 * numeric id of an Instagram/TikTok/Facebook post).
 */
export type SocialMediaPostId = Opaque<string, 'SocialMediaPostId'>;

function SocialMediaPostIdFactory(
  socialMediaPostId: string,
): SocialMediaPostId {
  return socialMediaPostId as SocialMediaPostId;
}

export { SocialMediaPostIdFactory };
